import axios from 'src/axios'
import { REDEEMREQUESTROUTES } from 'src/router/Api'

export interface RedeemRequestParams {
	offset?: number
	limit?: number
	q?: string
	status?: string
	from?: string
	to?: string
}

export const getRedeemRequests = async (params: RedeemRequestParams) =>
	await axios.get(REDEEMREQUESTROUTES.list, { params })

export const getRedeemRequestStats = async (params: Pick<RedeemRequestParams, 'from' | 'to'>) =>
	await axios.get(REDEEMREQUESTROUTES.stats, { params })

export const markRedeemRequestPaid = async (id: string) =>
	await axios.post(REDEEMREQUESTROUTES.markPaid(id))

export const rejectRedeemRequest = async (id: string, rejection_reason: string) =>
	await axios.post(REDEEMREQUESTROUTES.reject(id), { rejection_reason })
